import React, { useEffect } from 'react';


export default function ProfileImage(props) {
    //const { setDispMsg } = useContext(ProductContext)
    const inputRef = React.useRef();
    const triggerFileSelectPopup = () => inputRef.current.click();
  //  const [image, setImage] = useState('');
    const { profileImage, setAlertDetails, setImageFile, alertDetails}=props;
    //const [loader, showLoader, hideLoader] = useFullPageLoader(); 

useEffect(() => {
  
}, [profileImage])

   const handleFileSelection = (event)=>{
     event.preventDefault();
     if (event.target.files && event.target.files.length > 0) {
       setImageFile(event.target.files[0]);
       //console.log("selected file : ", event.target.files[0].name);
       var tprofile = document.getElementById("profile");
       tprofile.src=URL.createObjectURL(event.target.files[0]);
       setAlertDetails({
        ...alertDetails,
        style:"info",
        open:true,
        message:"File Selected - "+ event.target.files[0].name
    });   
   }else{
    setAlertDetails({
      ...alertDetails,
      style:"info",
      open:true,
      message:"No Files selected"
  });   
   }
  }

   const handleImageError=(e)=>{
     console.log("Event : ", e);
    //e.target.src = "https://s3.ap-south-1.amazonaws.com/dev.idntica.com/avatar/profileImage/defaultAvatar.jpeg"
   }

    return (
      <div style={{textAlign:"center"}}> 
      
       {profileImage ? <img id="profile" src={profileImage} 
            onError={handleImageError}
            alt="Profile" style={{width:"6rem", height:"6rem", borderRadius:"50%"}} />
       :null}
       
        <input
          type="file"
          accept="image/*"
          ref={inputRef}
          onChange={handleFileSelection}
          style={{ display: "none" }}
        />
        
        <span style={{backgroundColor:'primary', width:'120px', height:'120px', borderRadius:"20%", position:'relative', left:'-20px', top:'35px', zIndex:"999"}}>
            <i className='overlay-profile fa fa-camera' onClick={triggerFileSelectPopup} style={{ border:'2px solid white', borderRadius:'50%',color:'black', left:'-20px', top:'35px', fontSize:'20px', zIndex:'500', cursor:'pointer'}}></i>
            </span>
        </div>
      
    )

}